import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { BlogDevelopmentService } from '../blog-development.service';
import { BlogDevelopment } from '../blog-development';

@Component({
    selector: 'app-blog-development',
    templateUrl: './blog-development.component.html',
    styleUrls: ['./blog-development.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class BlogDevelopmentComponent implements OnInit {

	@Input() blogDevelopment: BlogDevelopment;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	blogDevelopmentId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private blogDevelopmentService: BlogDevelopmentService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.blogDevelopment = data.blogDevelopment,
			this.statuses = blogDevelopmentService.statuses;
	}

	

	validationMessages = {
		'blogDevelopmentId': [],
		'addressDevelopmentName': [
			{ type: 'required', message: 'Required' }],
		'blogId': [],
		'developmentId': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole blogDevelopment object
		if (this.blogDevelopment) {
			this.blogDevelopmentId = this.blogDevelopment.blogDevelopmentId;
			this.form1.patchValue(this.blogDevelopment);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.blogDevelopmentId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.blogDevelopmentService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.blogDevelopment = res.data.blogDevelopment;
						this.doAdd.emit(this.blogDevelopment);
					},
					(err: any) => {
						console.log('blogDevelopment-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('blogDevelopment: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.blogDevelopmentService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.blogDevelopment = res.data.blogDevelopment;
						this.doUpdate.emit(this.blogDevelopment);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
    try {
      this.blogDevelopmentService
        .delete(
          this.blogDevelopment?.blogId,
          this.blogDevelopment?.developmentId
        )
        .subscribe(
          (res: any) => {
            console.log(
              "blogDevelopment-delete SUCCESS: " +
                JSON.stringify(res)
            );
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: res.message,
            });
            this.doDelete.emit(this.blogDevelopment);
          },
          (err: any) => {
            console.log(
              "blogDevelopment-delete FAIL: " + JSON.stringify(err)
            );
            this.alertService.error(err);
          },
          () => {
            this.formLoading = false;
          }
        );
    } catch (error) {
      this.alertService.error(error);
    }
  }

	formBuild() {
		this.form1 = this.formBuilder.group({
			blogDevelopmentId: [this.blogDevelopmentId],
			addressDevelopmentName: ['', Validators.required],
			blogId: [this.blogDevelopment?.blogId],
			developmentId: [this.blogDevelopment?.developmentId],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.blogDevelopment.blogDevelopmentDate = moment(this.blogDevelopment.blogDevelopmentDate).toDate();
	}
}
